/* ==========================================================================
   SitesRijeka custom behaviour
   Scroll reveal, staggered entrances, and header scroll state.

   Safety model: the [data-sr] attribute that hides an element is only ever
   applied from this script. If the script fails to parse or run, no element
   is hidden and the page renders as plain static content. A watchdog also
   force reveals everything after a short delay if the observer never fires.
   ========================================================================== */
(function () {
  'use strict';

  var REVEAL_ATTR = 'data-sr';
  var IN_CLASS = 'sr-in';
  var DONE_CLASS = 'sr-done';
  var STAGGER_MS = 80;
  var MAX_STAGGER_MS = 400;
  var WATCHDOG_MS = 2500;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* In the theme editor, merchants need to see blocks immediately while they
     edit, so motion is skipped entirely there. */
  var inThemeEditor =
    document.documentElement.classList.contains('shopify-design-mode') ||
    (window.Shopify && window.Shopify.designMode);

  if (prefersReducedMotion || inThemeEditor) return;
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add(IN_CLASS);
        observer.unobserve(el);
        window.setTimeout(function () {
          el.classList.add(DONE_CLASS);
        }, 1000);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    }
  );

  function register(el, delayMs, variant) {
    if (!el || el.hasAttribute(REVEAL_ATTR)) return;
    el.setAttribute(REVEAL_ATTR, variant || '');
    if (delayMs) {
      el.style.setProperty('--sr-delay', delayMs + 'ms');
    }
    observer.observe(el);
  }

  var STAGGER_SELECTOR = [
    '.card',
    '.product-card',
    '.resource-card',
    '.sr-panel',
    '.collection-list__item',
    '.product-grid > li',
    '.collection-grid > li'
  ].join(',');

  function scan(root) {
    var sections = root.querySelectorAll('.shopify-section');

    Array.prototype.forEach.call(sections, function (section) {
      var groups = section.querySelectorAll(STAGGER_SELECTOR);

      if (groups.length > 1) {
        /* Stagger the tiles rather than the whole section, so a product grid
           resolves item by item instead of as one heavy block. */
        Array.prototype.forEach.call(groups, function (item, i) {
          register(item, Math.min(i * STAGGER_MS, MAX_STAGGER_MS), 'scale');
        });
      } else {
        register(section, 0, '');
      }
    });

    var loose = root.querySelectorAll('.sr-panel, .sr-frame, .sr-underline');
    Array.prototype.forEach.call(loose, function (el) {
      register(el, 0, '');
    });
  }

  function revealAll() {
    var hidden = document.querySelectorAll('[' + REVEAL_ATTR + ']:not(.' + IN_CLASS + ')');
    Array.prototype.forEach.call(hidden, function (el) {
      el.classList.add(IN_CLASS, DONE_CLASS);
    });
  }

  var scrollTicking = false;
  function onScroll() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      document.body.classList.toggle('sr-scrolled', window.scrollY > 24);
      scrollTicking = false;
    });
  }

  function init() {
    scan(document);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(revealAll, WATCHDOG_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.nodeType === 1) {
      scan(event.target);
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) revealAll();
  });
})();
